export default __webpack_public_path__ + "static/media/PK.99da496a.jpg";